import HomePagePopUpRegistry from '../../registries/HomePagePopUpRegistry';

import {
  EMMA_BETTER_ME,
  EMMA_NOTICES,
  EMMA_AXA_GOAL,
  EMMA_INTRO,
  EMMA_EB_FLEXI,
} from '../../constants/constants';

const init = () => {
  HomePagePopUpRegistry.register(EMMA_INTRO, 5);
  // Emma Notice has been disabled.
  // HomePagePopUpRegistry.register(EMMA_NOTICES, 100);
  HomePagePopUpRegistry.register(EMMA_BETTER_ME, 200);
  HomePagePopUpRegistry.register(EMMA_AXA_GOAL, 300);
  HomePagePopUpRegistry.register(EMMA_EB_FLEXI, 400);
};

export { init };
